export default "__VITE_PUBLIC_ASSET__cb5f9b17__"